module.exports = __webpack_public_path__ + "img/spinner.d47e58c7.gif";